<template lang='pug'>
.row.fpui-select-list
  .col-xs-3.categories(v-if='categories')
    h2 Categories
    ul.source-types
      li(
        @click="filterByCategory(key, category)"
        v-for="category, key in categories"
        :class="{active: activeCategory === key, 'no-icon': !category.icon}"
      )
        span {{ category.name | translate }}
  .items(:class='categories ? "col-xs-9" : "col-xs-12"')
    fpui-input-search(v-model='search', color='blue')
    .row
      .item-container.col-md-6.col-xs-12(
        v-for="item, idx in filteredItems",
        v-if="!item.hide",
        :key='idx',
        :class="{ 'col-lg-6': lg6, 'col-lg-4': !lg6 }"
      )
        .item(
          :class="{active: model === item.id, 'disabled': item.disabled}"
          @click="!item.disabled && update(item)"
          v-tooltip="disabledTooltip(item)"
        )
          .item-image
            img(v-if='item.image', :src='item.image')
            i(v-else, :class="item.icon || 'fpui fpui-module'")
          .item-informations(v-tooltip='item.description')
            .item-name {{ (item.name || item.id) | translate}}
            .item-category {{ categoryName(item) | translate}}
            .item-description(v-if='item.shortDescription') {{ item.shortDescription || '' }}
</template>

<script>
import get from 'lodash/get'

export default {
  props: {
    categories: Object,
    items: Array,
    value: String,
    lg6: { type: Boolean, default: false }
  },
  data () {
    return {
      activeCategory: 'all',
      search: ''
    }
  },
  computed: {
    filteredItems () {
      if (!this.items) return []
      return this.items.filter(item => {
        let show = true
        if (this.search) {
          show = Object.keys(item).some(key => {
            return typeof item[key] === 'string' && item[key].toLowerCase().indexOf(this.search.toLowerCase()) !== -1
          })
        }
        if (this.activeCategory !== 'all' && show === true) {
          show = item.category === this.activeCategory
        }
        return show
      })
    },
    model: {
      get () { return this.value },
      set (val) { return this.$emit('input', val) }
    }
  },
  methods: {
    filterByCategory (key) { this.activeCategory = key },
    categoryName (item) { return get(this, `categories.${item.category}.name`) || item.category },
    update (item) { this.model = item.id },
    disabledTooltip (item) { return item.disabled ? this.$t('not_available') : '' }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

.fpui-select-list {
  min-height: 300px;
  .categories {
    h2 {
      text-transform: lowercase !important;
      font-variant: small-caps !important;
      margin: 0 0 20px 0 !important;
      letter-spacing: 1px !important;
      font-size: 18pt !important;
      font-weight: 400 !important;
    }
    ul.source-types {
      list-style-type: none;
      padding: 0;
      ::selection {
        background: transparent;
      }
      li {
        transition: all 0.25s;
        text-align: left;
        padding-left: 10px;
        cursor: pointer;
        &:hover,&.active {
          background-color: @blueLight;
        }
        i {
          color: @blue;
          font-size: 175%;
          padding-right: 10px;
          display: inline-block;
          vertical-align: middle;
        }
        span {
          font-size: 10pt;
          vertical-align: middle;
          display: inline-block;
          line-height: 20px;
        }
        &.no-icon {
          padding: 5px 0;
          span {
            padding-left: 42px;
          }
        }
      }
    }
  }
  .items {
    .fpui-input-search {
      padding: 0px 5px;
      i.fpui {
        left: 5px;
      }
    }
    .row {
      max-height: 500px;
      margin: 10px 0 0 0;
      overflow: auto;
      .create-extension {
        display:none;
      }
      .item-container {
        padding: 5px;
        .item {
          height:120px;
          padding: 10px;
          position: relative;
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          border: 2px solid white;
          transition: all 0.25s;
          &.disabled {
            border: 2px solid lighten(@grey, 10%);
            background-color: lighten(@grey, 10%);
            opacity: .5;
            cursor: not-allowed;
          }
          &.create {
            line-height:100px;
            text-align: center;
            font-size:20px;
            color:#bbb;
          }
          &:hover:not(.disabled), &.active {
            border-color: @blue;
            background-color: @blueLight;
            .item-image {
              -webkit-box-shadow: 0px 0px 10px -1px fade(@blue, 35%);
              -moz-box-shadow: 0px 0px 10px -1px fade(@blue, 35%);
              box-shadow: 0px 0px 10px -1px fade(@blue, 35%);
              border-color: fade(@blue, 40%);
              i {
                line-height: 76px;
                font-size: 26pt;
              }
            }
            .item-informations {
              .item-description:after {
                background-color: @blueLight;
              }
            }
          }
          &:hover:not(.disabled) {
            cursor: pointer;
          }
          .item-image {
            text-align: center;
            position: relative;
            height: 75px;
            width: 75px;
            margin: 12.5px 20px 0 10px;
            overflow: hidden;
            float: left;
            border: 1px solid #EBEBEB;
            border-radius: 20px;
            background-color: white;
            transition: box-shadow 0.25s;
            i {
              transition: all 0.25s;
              line-height: 75px;
              font-size: 25pt;
            }
            img {
              height: 70px;
              width: 70px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .item-informations {
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            align-content: center;
            .item-name {
              position: relative;
              font-size: 12pt;
              padding: 5px;
              width: 100%;
              align-self: center;
            }
            .item-category {
              position: relative;
              font-size: 9pt;
              color: #868687;
              padding: 5px;
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              align-self: center;
            }
          }
        }
      }
    }
  }
}
</style>
